import { useEffect } from 'react';

const useServiceWorker = () => {

  const requestPermission = async () => {
    if (!('Notification' in window)) return false;
    if (Notification.permission === 'granted') return true;
    if (Notification.permission !== 'denied') {
      const permission = await Notification.requestPermission();
      return permission === 'granted';
    }
    return false;
  };

  // ✅ Notification instantanée — pas de SW.ready
  const sendSWNotification = async (title, body, tasks = []) => {
    const permitted = await requestPermission();
    if (!permitted) return;

    // Si onglet visible → Notification native directe (instantané)
    if (document.visibilityState === 'visible') {
      const notification = new Notification(title, {
        body,
        icon: '/logo.png',
        badge: '/logo.png',
        tag: 'new-tasks',
        requireInteraction: true,
        silent: false,
      });

      notification.onclick = () => {
        window.focus();
        window.location.href = '/support-technique/taches-a-confirmer';
        notification.close();
      };

      return;
    }

    // Si onglet inactif → SW (acceptable d'avoir un léger délai)
    try {
      const registration = await navigator.serviceWorker.ready;
      await registration.showNotification(title, {
        body,
        icon: '/logo.png',
        badge: '/logo.png',
        tag: 'new-tasks',
        requireInteraction: true,
        vibrate: [200, 100, 200],
        data: { url: '/support-technique/taches-a-confirmer', tasks },
        actions: [
          { action: 'open', title: '👁️ Voir les tâches' },
          { action: 'close', title: '✕ Fermer' }
        ]
      });
    } catch (error) {
      console.error('❌ Erreur SW notification:', error);
    }
  };

  useEffect(() => {
    // Enregistrer le SW en arrière-plan sans bloquer
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/sw.js')
        .then(() => console.log('✅ SW enregistré'))
        .catch(err => console.error('❌ SW erreur:', err));
    }
  }, []);

  return { sendSWNotification, requestPermission };
};

export default useServiceWorker;